import { useSmartQuery } from "@shared/api/queries/hooks";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";

import { dashboardApi } from "./api";
import { JobCardFilters } from "./types";

export const useDashboardOverview = (params: { remote_utility_id: any }) => {
  return useSmartQuery(
    QueryKeyFactory.module.wx.dashboard.dashboardOverview(params),
    () => dashboardApi.getDashboardOverview(params)
  );
};

export const useDashboardServiceOrders = (params: {
  remote_utility_id: any;
  days: string;
}) => {
  return useSmartQuery(
    QueryKeyFactory.module.wx.dashboard.dashboardServiceOrders(params),
    () => dashboardApi.getDashboardServiceOrders(params)
  );
};

export const useDashboardSlaPerformance = (params: {
  remote_utility_id: any;
}) => {
  return useSmartQuery(
    QueryKeyFactory.module.wx.dashboard.dashboardSlaPerformance(params),
    () => dashboardApi.getDashboardSlaPerformance(params)
  );
};

export const useDashboardSopBySource = (params: {
  remote_utility_id: any;
  days: string;
}) => {
  return useSmartQuery(
    QueryKeyFactory.module.wx.dashboard.dashboardSopBySource(params),
    () => dashboardApi.getDashboardSopBySource(params)
  );
};

export const useDashboardSopCost = (params: { remote_utility_id: any }) => {
  return useSmartQuery(
    QueryKeyFactory.module.wx.dashboard.dashboardSopCost(params),
    () => dashboardApi.getDashboardSopCost(params)
  );
};

export const useDashboardRecentJobCards = (filters: JobCardFilters) => {
  // Include filters in query key for proper caching
  const queryKey =
    QueryKeyFactory.module.wx.dashboard.dashboardRecentJobCards(filters);

  const enabled = !!filters.utilityId;

  return useSmartQuery(
    queryKey as unknown[],
    () => dashboardApi.getDashboardRecentJobCards(filters),
    { enabled } // Only run when remote_utility_id is available
  );
};
